import "./loader.scss";

const Loader = () => {
    return (
        <div className="loader">
            <div className="square" id="sq1" />
            <div className="square" id="sq2" />
            <div className="square" id="sq3" />
            <div className="square" id="sq4" />
            <div className="square" id="sq5" />
            <div className="square" id="sq6" />
            <div className="square" id="sq7" />
            <div className="square" id="sq8" />
            <div className="square" id="sq9" />
        </div>
    );
}

export default Loader;
